import { DateTime } from "luxon";
export const convertTimestampToLuxonOrDefaultNow = (timestamp) => {
    if (timestamp?.toDate) {
        return DateTime.fromJSDate(timestamp.toDate());
    }
    return DateTime.now();
};
//# sourceMappingURL=convertTimestampToLuxonOrDefaultNow.js.map